import React from 'react';
import { SVGProps } from './type';

export const IconUserManagement = ({ fill }: SVGProps) => {
  return (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.199 11.947a3.75 3.75 0 0 0 -3.748 3.75v4.997a1.249 1.249 0 0 1 -2.499 0v-4.998c0 -2.154 1.091 -4.054 2.749 -5.178a5 5 0 1 1 8.466 -4.133A5 5 0 0 1 19.65 13.758a4.47 4.47 0 0 1 2.295 3.901v3.036a1.249 1.249 0 0 1 -2.499 0v-3.036a1.965 1.965 0 0 0 -1.963 -1.963H14.448v4.998a1.249 1.249 0 0 1 -2.499 0v-4.998a3.75 3.75 0 0 0 -3.75 -3.75m7.5 1.249a2.499 2.499 0 1 0 0 -5 2.499 2.499 0 0 0 0 5m-7.5 -3.75a2.499 2.499 0 1 1 0 -4.998 2.499 2.499 0 0 1 0 5"
        fill={fill}
      />
    </g>
  );
};
